import styled from 'styled-components';

export const ArchiveDeleteTaskHint = styled('span')`
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 3rem;
`;

export const ArchiveDeleteTaskContainer = styled('div')`
  height: 100%;
  display: flex;
  flex-direction: column;
  & > * {
    margin-inline-end: 0 !important;
    border-inline-start: 0 !important;
    padding-inline-start: 0 !important;
  }
`;

export const ArchiveTaskWrapper = styled('div')`
  flex: 0.5;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const DeleteTaskWrapper = styled('div')`
  flex: 0.5;
  display: flex;
  border-top: 1px solid #c8cee0;
  padding-top: 1rem;
  flex-direction: column;
  justify-content: flex-start;
`;
